<template>
  <section class="CasinoGames GamesList GamesListGrid MsnRow" v-if="games">
    <h2 class="BoxTitle GamesContainerTitle">
      <router-link :to=" {name: ((live) ? 'LiveCasino' : 'Casino'), query: {provider: provider.id}}" class="ComponentAnchor GameCategory Anchor Anchor " id="CategoryGameList-Nur-bei-uns">
        {{ provider.name }}
      </router-link>
    </h2>
    <div class="GamesSwipeable">
      <div class="GamesWrapper">
        <ul class="GamesListContainer HorizontalScrollBar HasLoadMoreButton List ListUnordered " v-infinite-scroll="fetchGames" infinite-scroll-disabled="busy" infinite-scroll-distance="5">
          <li class="ListGame ListItem GameTileContainer MasonryTile-1x1" v-for="game in games">
            <a class="ComponentAnchor GamePlayNowButton Anchor " v-on:click="openGame(game)" :title="game.name">
                  <span class="SvgIcon PlayButton">
                     <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
                        <path fill="#fff" d="M37.862 28.75l-15.32 9.913A.999.999 0 0121 37.824V18a1 1 0 011.543-.84l15.32 9.912a1.002 1.002 0 01-.001 1.679z"></path>
                        <path fill="#fff" d="M28 54c14.36 0 26-11.64 26-26S42.36 2 28 2 2 13.64 2 28s11.64 26 26 26zm0 2C12.536 56 0 43.464 0 28S12.536 0 28 0s28 12.536 28 28-12.536 28-28 28z"></path>
                     </svg>
                  </span>
            </a>
            <img class="GameThumb ListGameImage LazyImage" :alt="game.name" onerror="this.onerror=null;this.src = this.src.replace('.gif', '.jpg')"  :src="game.thumbnail">
            <div class="GameProp GameVendor SubVendor" itemprop="author">{{ game.vendor.name }}</div>
            <div class="GameProp NewGame">NEU</div>
            <h3 class="GameTitle" itemprop="name">{{ game.name | slimiter(20) }}</h3>
          </li>
        </ul>
        <router-link :to=" {name: ((live) ? 'LiveCasino' : 'Casino'), query: {provider: provider.id}}" class="ComponentAnchor TipicoViewAllGames ComponentButton InstanceLoadMoreGames Button Anchor " id="ViewAllGames-Merkur-Spiele">
          <div class="DiffAndTotalGamesWrapper HasDiffBetweenTotalAndDisplayedGames" id="ViewAllGames-Merkur-Spiele-Wrapper">
            <span class="TextNoOfGames" id="ViewAllGames-Merkur-Spiele-Text">{{ t.all_games }}</span>
            <span class="NoOfGames Total" id="ViewAllGames-Merkur-Spiele-Total">{{ total }}</span><span class="NoOfGames Diffrence" id="ViewAllGames-Merkur-Spiele-Diff">42</span></div>
          <span class="ComponentIcon InstanceArrowRight ButtonIconEnd Icon" id="ViewAllGames-Merkur-Spiele-IconWrapper">
            <span class="SvgIcon MainIcon" id="ViewAllGames-Merkur-Spiele-Icon">
               <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                  <path fill-rule="evenodd" d="M11 9.077L13.063 7 22 16l-8.937 9L11 22.923 17.875 16"></path>
               </svg>
            </span>
         </span>
        </router-link>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  name: 'providerGames',
  props: ['provider', 'live'],
  data () {
    return {
      games: null,
      total: 0,
      t: this.$root.t,
      bsapi: bsapi,
    }
  },
  mounted() {

    if(this.provider.id)
      this.fetchGames()
  },
  methods: {
    openGame(g) {
      this.$parent.openGame(g);
    },
    fetchGames() {
      this.$http.get(api + 'api/v1/casino/games', {
        params: {
          page: 1,
          provider: [this.provider.id],
          per_page: 7,
          device: 'desktop'
        },

      }).then(response => {

        var th = this;
        this.games = [];
        response.body.result.forEach(function(item) {
          th.games.push(item.game);
        });
        this.total = response.body.pagination.totalCount;
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/casino/widget/providerGames.vue